import PropTypes from 'prop-types';
import {useState, useEffect} from 'react';
import {Container, Divider, Header} from 'semantic-ui-react';
import './DashboardPage.scss';
import * as ImageLoaderApi from 'api/ImageLoaderApi';
import PropertySearch from 'components/PropertySearch';
import ReportHistorySection from 'components/ReportHistorySection';
import connected from 'connected';

export function DashboardPage(props) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [style, setStyle] = useState({});

  useEffect(() => {
    setIsLoaded(true);
  }, [isLoaded]);

  useEffect(() => {
    try {
      ImageLoaderApi.getBackgroundImage().then(data => {
        setStyle({
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${data})`,
        });
      });
    } catch (e) {
      //Do nothing, backgroundImage is undefined.
    }
  }, [isLoaded]);

  return (
    <div className="dashboard-background" style={style}>
      <Container className="dashboard-page">
        <div className="heading-row">
          <Header as="h1" size="huge">Create a new report</Header>
        </div>
        <div className="search-row">
          <PropertySearch/>
        </div>
        <Divider hidden/>
        <ReportHistorySection/>
      </Container>
    </div>
  );
}

DashboardPage.propTypes = {
  propertySearch: PropTypes.object,
};

export default connected(DashboardPage);
